export default __webpack_public_path__ + "static/media/white_queen.6e51083b.png";